export default __webpack_public_path__ + "static/laitteetbg-c45bb2b4ea809da387bd3656927fcbee.svg";